import { ApiError, SessionExpiredError } from "../api/api-error";
/**
 * The one place an error becomes a sentence.
 *
 * Everything a screen catches arrives here: an `ApiError` carrying the server's
 * `messageKey` and `params`, a `SessionExpiredError` raised by the client's own
 * refresh logic, or a `TypeError` from a dead radio. All three have to end as
 * something a person can read, and none of them may end as `error.message` —
 * that field is developer-facing on every one of them, and on `ApiError` it is
 * deliberately allowed to be more specific than anything a user should see
 * (`D27`).
 *
 * `code` is not consulted here either. It is for a caller deciding whether to
 * retry, re-authenticate or give up; it is far too coarse to select a sentence.
 */
export function toUserMessage(translate, error) {
    if (error instanceof ApiError) {
        return translate(error.messageKey, error.params);
    }
    if (error instanceof SessionExpiredError) {
        return translate("auth.session_expired");
    }
    // A thrown value that is not one of ours: a network failure, a JSON parse
    // error, a bug. The user cannot act on the difference, and naming it would
    // mean rendering a developer string.
    return translate("error.internal");
}
//# sourceMappingURL=error-message.js.map